/* eslint-disable */
import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import * as Store from '@apply/store';
import { ShowIf } from '@apply/ui';
import { useAuthentication } from '../../LoginPage';
import { alertModal } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { BusinessAndPeopleApi } from '@apply/api';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { LoadPanel } from 'devextreme-react/load-panel';
import { NumericFormat } from 'react-number-format';

export interface IEditBorrowerOwnerPeopleGroupModalProps {
    isOpen: boolean;
    onCloseCallback?: () => void;
    applicationInsights: ApplicationInsights;
    borrowerEntityId: any;
    selectedBusinessId: any;
    peopleGroupId: any;
}

export const EditBorrowerOwnerPeopleGroupModal: React.FC<IEditBorrowerOwnerPeopleGroupModalProps> = ({
    isOpen,
    onCloseCallback,
    applicationInsights,
    borrowerEntityId,
    selectedBusinessId,
    peopleGroupId,
}) => {
    const businessAndPeopleApi = new BusinessAndPeopleApi.BusinessAndPeopleApi(applicationInsights);

    const { authentication, isFeatureEnabled } = useAuthentication();
    const [validation, set_validation] = useState(undefined);
    const [loadingMessage, set_loadingMessage] = useState('');
    const [loadingOpen, set_loadingOpen] = useState(false);
    const [saveEnabled, set_saveEnabled] = useState(false);

    const [peopleGroup, set_peopleGroup] = useState(null);
    const [canContinue, set_canContinue] = useState(true);

    const [businessId, set_businessId] = useState<number>(0);
    const [entityId, set_entityId] = useState(null);
    const [percentageOwnership, set_percentageOwnership] = useState(0);
    const [groupOwnNameInvestment, set_groupOwnNameInvestment] = useState<boolean>(false);
    const [singleInvestorNotMoreThan20Percent, set_singleInvestorNotMoreThan20Percent] = useState<boolean>(false);

    const styles = {
        button: {
            width: 150,
        },
        noPadding: {
            padding: 0,
        },
        checkbox: {
            marginRight: '10px',
            marginTop: '5px',
        },
    };

    useEffect(() => {
        set_businessId(selectedBusinessId);
    }, [selectedBusinessId]);

    useEffect(() => {
        set_entityId(borrowerEntityId);
    }, [borrowerEntityId]);

    const loadDetails = async (id: number) => {
        // set_loadingMessage("Loading...");
        // set_loadingOpen(true);
        // const response = await businessAndPeopleApi.getPeopleGroupById(id);
        // if (!response || response.statusCode !== 200) {
        //   return;
        // }
        // set_peopleGroup(response.result);
    };

    useEffect(() => {
        async function peopleGroupIdChanged() {
            resetState();
            if (!peopleGroupId || peopleGroupId <= 0) {
                set_peopleGroup(null);
                return;
            }

            await loadDetails(peopleGroupId);
            set_loadingOpen(false);
        }

        peopleGroupIdChanged();
    }, [peopleGroupId]);

    useEffect(() => {
        setState(peopleGroup);
    }, [peopleGroup]);

    useEffect(() => {
        let fieldsValid = false;

        fieldsValid = percentageOwnership > 0 && groupOwnNameInvestment && singleInvestorNotMoreThan20Percent;

        set_canContinue(fieldsValid);
    }, [percentageOwnership, groupOwnNameInvestment, singleInvestorNotMoreThan20Percent]);

    const setState = (peopleGroup: any) => {
        if (!peopleGroup) {
            return;
        }
        set_percentageOwnership(peopleGroup.percentageOwnership);
        set_groupOwnNameInvestment(peopleGroup.groupOwnNameInvestment);
        set_singleInvestorNotMoreThan20Percent(peopleGroup.singleInvestorNotMoreThan20Percent);
    };

    const resetState = () => {
        set_businessId(0);
        set_entityId(null);
        set_percentageOwnership(0);
        set_groupOwnNameInvestment(false);
        set_singleInvestorNotMoreThan20Percent(false);
    };

    const getSuccessMessage = (id: number) => {
        if (id === 0) {
            return 'Your Borrower Entity Owner - People Group was added successfully.';
        } else {
            return 'Your Borrower Entity Owner - People Group was updated successfully';
        }
    };

    const getGeneralErrorMessage = () => {
        return 'An error has occurred while communicating with our server.  Please try your operation again.';
    };

    const handleClose = () => {
        set_peopleGroup(null);
        set_validation(undefined);
        resetState();
        onCloseCallback(null);
    };

    const cancelBorrowerEntityOwnerPeopleGroup = () => {
        set_peopleGroup(null);
        set_validation(undefined);
        resetState();
        onCloseCallback(null);
    };

    const validatePeopleGroup = async () => {
        ////Check should validate whether one people group owner already exists on a borrower entity or not
        // set_loadingMessage("Validating...");
        // set_loadingOpen(true);
        // set_validation(undefined);
        // try {
        //   const model = {
        //     entityId,
        //     id: peopleGroupId
        //   };
        //   const response = await businessAndPeopleApi.validatePeopleGroup(model);
        //   if (response.statusCode !== 200 || !response.result) {
        //     set_loadingOpen(false);
        //     return false;
        //   }
        //   if (response.result.hasErrors || response.result.hasWarnings) {
        //     set_validation(response.result);
        //     set_loadingOpen(false);
        //     return false;
        //   }
        //   return true;
        // } catch (ex) {
        //   set_loadingOpen(false);
        //   set_validation(undefined);
        //   alertModal({
        //     message:
        //       getGeneralErrorMessage(),
        //   });
        //   return false;
        // }
    };

    const savePeopleGroup = async () => {
        // try {
        //   const isValid = await validatePeopleGroup();
        //   if (!isValid) {
        //     return;
        //   }
        //   const model = {
        //     entityId: borrowerEntityId,
        //     peopleGroupId: peopleGroupId ?? 0,
        //     percentageOwnership,
        //     groupOwnNameInvestment,
        //     singleInvestorNotMoreThan20Percent
        //   };
        //   const response = await businessAndPeopleApi.saveBorrowerEntityOwnerPeopleGroup(model);
        //   if (response.statusCode !== 200 || !response.result) {
        //     set_loadingOpen(false);
        //     alert(response.errors[0]);
        //     return false;
        //   }
        //   set_loadingOpen(false);
        //   alertModal({
        //     title: "Success",
        //     message: getSuccessMessage(model.peopleGroupId),
        //     onConfirm: () => {
        //       handleClose();
        //     },
        //   });
        // } catch (ex) {
        //   set_loadingOpen(false);
        //   set_validation(undefined);
        //   alertModal({
        //     message:
        //       getGeneralErrorMessage(),
        //   });
        //   return false;
        // }
    };

    return (
        <div>
            <Dialog
                open={isOpen}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
                maxWidth='md'
            >
                <DialogContent>
                    <div className='modal-container'>
                        <div className='modal-backdrop'></div>
                        <div
                            className='modal'
                            role='dialog'
                            style={{ width: '500px', maxWidth: '80vw' }}
                        >
                            <div
                                className='modal-dialog'
                                role='document'
                            >
                                <div
                                    className='page-header'
                                    role='banner'
                                >
                                    <h1>
                                        {!peopleGroupId && peopleGroupId === 0
                                            ? 'Add Owner (People Group)'
                                            : 'Edit Owner (People Group)'}
                                    </h1>
                                    <button
                                        type='button'
                                        className='close'
                                        data-dismiss='modal'
                                        aria-label='Close'
                                        onClick={handleClose}
                                    >
                                        <span aria-hidden='true'>&times;</span>
                                    </button>
                                </div>
                                <div className='modal-content '>
                                    <div className='modal-body'>
                                        <div
                                            className='standard-form'
                                            style={styles.noPadding}
                                        >
                                            <div
                                                className='scrollable-content'
                                                style={{ margin: '10px' }}
                                            >
                                                <ShowIf showIf={validation?.hasErrors}>
                                                    {validation?.messages?.map((m) => {
                                                        return (
                                                            <div className='row'>
                                                                <div className='columns small-12 large-12'>
                                                                    <div>
                                                                        <span
                                                                            style={{
                                                                                color: 'red',
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon
                                                                                icon={faExclamationTriangle}
                                                                                style={{
                                                                                    color: 'red',
                                                                                }}
                                                                            />
                                                                            &nbsp;
                                                                            <span
                                                                                dangerouslySetInnerHTML={{
                                                                                    __html: m.message,
                                                                                }}
                                                                            />
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </ShowIf>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <label htmlFor='name'>
                                                            Percentage of Ownership
                                                            <span className='req'>*</span>
                                                        </label>
                                                        <span className='helper'>
                                                            <span className='tooltip-trigger'>
                                                                <FontAwesomeIcon icon={faCircleQuestion} />
                                                            </span>
                                                            <span className='text'>
                                                                Percent of Borrower Entity owned by this Group.
                                                            </span>
                                                        </span>
                                                        <NumericFormat
                                                            thousandSeparator=','
                                                            suffix='%'
                                                            id='percentageOwnership'
                                                            value={percentageOwnership ?? ''}
                                                            decimalScale={2}
                                                            allowNegative={false}
                                                            onValueChange={(values) => {
                                                                set_percentageOwnership(values.floatValue);
                                                            }}
                                                            required={false}
                                                            isAllowed={(values, sourceInfo) => {
                                                                const value = values?.floatValue;
                                                                return (
                                                                    value === undefined ||
                                                                    value === null ||
                                                                    (value >= 0 && value <= 100)
                                                                );
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                alignItems: 'flex-start',
                                                                paddingTop: '5px',
                                                            }}
                                                        >
                                                            <input
                                                                type='checkbox'
                                                                id='groupOwnNameInvestment'
                                                                checked={groupOwnNameInvestment}
                                                                style={styles.checkbox}
                                                                onChange={(event) =>
                                                                    set_groupOwnNameInvestment(event.target.checked)
                                                                }
                                                                required={true}
                                                            />
                                                            <label htmlFor='groupOwnNameInvestment'>
                                                                I represent and warrant that each person in this group will invest
                                                                in their own name and through an entity.
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='columns small-12 large-12'>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                alignItems: 'flex-start',
                                                                paddingTop: '5px',
                                                            }}
                                                        >
                                                            <input
                                                                type='checkbox'
                                                                id='singleInvestorNotMoreThan20Percent'
                                                                checked={singleInvestorNotMoreThan20Percent}
                                                                style={styles.checkbox}
                                                                onChange={(event) =>
                                                                    set_singleInvestorNotMoreThan20Percent(event.target.checked)
                                                                }
                                                                required={true}
                                                            />
                                                            <label htmlFor='singleInvestorNotMoreThan20Percent'>
                                                                I represent and warrant that among this group of people, a single
                                                                individual will not directly or indirectly own or control more
                                                                than 20% of the Borrower Entity and/or the collateral property.
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='modal-content-actions'>
                                                <button
                                                    type='button'
                                                    data-testid='accept-button'
                                                    className='button primary'
                                                    style={styles.button}
                                                    onClick={cancelBorrowerEntityOwnerPeopleGroup}
                                                >
                                                    Cancel
                                                </button>
                                                <button
                                                    type='button'
                                                    data-testid='accept-button'
                                                    className='button primary'
                                                    style={styles.button}
                                                    onClick={savePeopleGroup}
                                                    disabled={!canContinue || !saveEnabled}
                                                >
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions></DialogActions>
            </Dialog>
            <LoadPanel
                hideOnOutsideClick={false}
                visible={loadingOpen}
                message={loadingMessage}
            />
        </div>
    );
};
